module.exports = __webpack_public_path__ + "static/media/symantec.861c34bd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/symantec.gif
// module id = 388
// module chunks = 0